module.exports = __webpack_public_path__ + "img/product9.f192f159.png";